<h2 mat-dialog-title>
  {{data.title}}
</h2>
<mat-dialog-content class="mat-typography">
  <p>{{data.textContent}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>
